import authService from "@/services/auth";
import { mapActions, mapMutations } from "vuex";
import agencyService from "../../services/agency";
import conditionActivationService from "../../services/conditionActivation";
export default {
  components: {},
  data() {
    return {
      redirected: false,
      fullName: "",
    };
  },
  created() {
    this.impersonateUser();
  },
  methods: {
    ...mapActions("auth", {
      disconnect: "DISCONNECT",
      redirectAfterLogin: "REDIRECT_AFTER_LOGIN",
      clearToken: "CLEAR_TOKEN",
      setTokenManually: "SET_TOKEN_MANUALLY",
    }),
    ...mapMutations("auth", {
      setToken: "SET_TOKEN",
    }),
    disconnection() {
      this.disconnect();
    },
    refreshUserPage() {
      this.redirectAfterLogin(true);
    },
    impersonateUser() {
      const vue = this;
      const data = {
        token: this.$route.query.token,
      };
      authService
        .createImpersonate(data)
        .then((res) => {
          if (res.success) {
            vue.fullName = `${res.data.firstName} ${res.data.lastName}`;
            vue.clearToken();
            vue.setTokenManually(res.data);
            // Get pk Agency to conditional
            let pkAgency = '';
            agencyService.getAgence().then((agenceRes) => {
              pkAgency = agenceRes.data.agency.pkAgency;
            }).finally(() => {
               const email = res.data? res.data.email : null;
                if(email !==null) {
                 const params = {
                   email: encodeURIComponent(email),
                 }
                 pkAgency && (params.pkAgency = pkAgency)
                 conditionActivationService.getCondition(params).then((conditionRes) => {
                   if(conditionRes.success) {
                     localStorage.setItem("conditions", JSON.stringify(conditionRes.activation));
                   }
                 });
                }
               
              })
            
            vue.redirected = true;
          } else {
            vue.$router.push({ path: "/public/default" });
          }
        })
        .catch((err) => {
          vue.$router.push({ path: "/public/default" });
        });
    },
  },
};
